import { useDispatch } from "react-redux";
import {
  createEvent,
  deleteEvent,
  partialUpdateEvent,
  updateEvent,
} from "../../../actionCreator/calendarActionCreator";
import { getUserInfo } from "../../../utils/utils";
import { useAlert } from "../../../context/AlertProvider";
import { EventStatus } from "../../../config";

export const useEvent = () => {
  const dispatch = useDispatch();
  const { id: userId } = getUserInfo();
  const { showAlert } = useAlert();

  const handleCreateEvent = async (payload, callback) => {
    const formattedPayload = {
      ...payload,
      userId,
    };
    const res = await dispatch(createEvent(formattedPayload));
    if (res?.status === 200) {
      callback();
      showAlert("success", "Event added successfully.");
    } else {
      showAlert(
        "error",
        res.response.data.title || "Something went wrong. Please try again."
      );
    }
  };

  const handleUpdateEvent = async (payload, callback) => {
    const res = await dispatch(updateEvent(payload));
    if (res?.status === 200) {
      callback();
      showAlert("success", "Event updated successfully.");
    } else {
      showAlert(
        "error",
        res.response.data.title || "Something went wrong. Please try again."
      );
    }
  };

  const handleStatusUpdate = async (payload, callback) => {
    const res = await dispatch(partialUpdateEvent(payload));
    if (res?.status === 200) {
      callback();
      showAlert(
        "success",
        payload?.status === EventStatus?.CANCELLED
          ? "Event cancelled successfully."
          : "Event marked as completed successfully."
      );
    } else {
      showAlert(
        "error",
        res.response.data.title || "Something went wrong. Please try again."
      );
    }
  };

  const handleDeleteEvent = async (id, callback) => {
    const res = await dispatch(deleteEvent(id));

    if (res?.status === 200) {
      callback();
      showAlert("success", "Event deleted successfully.");
    } else {
      showAlert(
        "error",
        res.response.data.title || "Something went wrong. Please try again."
      );
    }
  };

  return {
    handleCreateEvent,
    handleDeleteEvent,
    handleUpdateEvent,
    handleStatusUpdate,
  };
};
